import axios from "@/helpers/interceptors";
import { ICountry, IReferenceItem} from "@/types";
import { MerchantPaymentMethod, UpdatesRegularity, CompanyType, ClientStatus, MerchantType } from "@/enums";
import { ref } from "vue";

// Define the state interface
interface RefsState {
  countryList: ICountry[];
}
const state: RefsState = {
  countryList: [],
};



const mutations = {
  SET_COUNTRY_LIST(state: RefsState, payload: any[]) {
    state.countryList = payload;
  },
};

const isLoadingCountryList = ref(false);

const actions = {
  async fetchCountryList({
    commit
  }: {
    commit: (mutation: string, payload?: any) => void;
  }) {
    try {
        if( isLoadingCountryList.value === true) {
            return
        }
        isLoadingCountryList.value = true
        const { status, data } = await axios.get("/api/registration/init/countries");
      
      if (status === 200 && data) {
        commit("SET_COUNTRY_LIST", data);
      }
    } catch (e) {
      console.log('Error fetching country list:', e);
    } finally {
        isLoadingCountryList.value = false
    }
  },

  async fetchAllReferences({
    dispatch
  }: {
    dispatch: (action: string, payload?: any) => Promise<void>;
  }) {
    await Promise.all([
      dispatch('fetchCountryList')
    ]);
  }
};

const getters = {
  countryList: (state: RefsState) => {
    return state.countryList;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
